import React from 'react';
import { Typography, Card } from 'antd';
import LeadershipByDimensions from '../components/leadershipByDimensions/leadershipByDimensions';
import LeadershipNPS from '../components/leadershipNPS/leadershipNPS';
import AverageTagSmall from '../components/averageTagSmall/averageTagSmall';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';
import { formatVisibleNumber, getEvaluationScoreColor, isIpraService } from '../components/selfcare360/selfcare360Scales';

const { Title, Text } = Typography;

const PageResultsByDimension = ({
    selectedEvaluation,
    dimension,
    pageNumber,
    type,
    strengths = [],
    gaps = [],
    recommended = [],
    notRecommended = [],
    chartData = [],
    isFirstPage = false,
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const getColor = (value) => getEvaluationScoreColor(value, {
        redLight: selectedEvaluation.evl_max_red_light,
        yellowLight: selectedEvaluation.evl_max_yellow_light,
        serviceId: selectedEvaluation?.evl_srv_id,
    });

    const weightPercent = Number(dimension?.weight_percent);
    const showWeight = isIpraService(selectedEvaluation?.evl_srv_id) && Number.isFinite(weightPercent);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info" style={{ position: "relative" }}>
                    <AverageTagSmall
                        average={dimension.average}
                        color={getColor(dimension.average)}
                        type={1}
                    />

                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '16px 24px' } }}
                    >
                        <Title level={4} style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}>
                            {dimension.title}
                        </Title>

                        {showWeight && (
                            <Text style={{ display: 'block', marginBottom: 12, color: '#5b5b5b' }}>
                                Peso configurado de la dimensión: <strong>{formatVisibleNumber(weightPercent)}%</strong>
                            </Text>
                        )}

                        {type === 1 && (
                            <LeadershipByDimensions
                                showCards={isFirstPage}
                                strengths={strengths}
                                gaps={gaps}
                                chartData={chartData}
                                redLight={selectedEvaluation.evl_max_red_light}
                                yellowLight={selectedEvaluation.evl_max_yellow_light}
                                serviceId={selectedEvaluation?.evl_srv_id}
                            />
                        )}

                        {type === 2 && (
                            <LeadershipNPS
                                showCards={isFirstPage}
                                recommended={recommended}
                                notRecommended={notRecommended}
                                chartData={chartData}
                                redLight={selectedEvaluation.evl_max_red_light}
                                yellowLight={selectedEvaluation.evl_max_yellow_light}
                            />
                        )}
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResultsByDimension;
